import baseService from './baseService';

export function authorizeSlack(code) {
  return baseService.post(`/slack/user_authorizations`, { code });
}

export const getIntegrationSettings = (organizationId) =>
  baseService.get(`/organizations/${organizationId}/organization_integrations`);

export const getSlackAuthoriztions = () => baseService.get('/slack/user_authorizations');

export const updateSlackUser = (slackUserId, referStatus) =>
  baseService.patch(`slack/user_authorizations/${slackUserId}`, { refer_status: referStatus });

export const postIntegrationRequest = (data) => baseService.post(`/member/integrations`, data);

export const addLinkedInAccount = (redirectPath) =>
  baseService.get('/member/integrations/linkedin_login', { params: { redirect_uri: redirectPath } });

export const linkedInAuthentication = (linkedInCode, redirectPath) =>
  baseService.post('/member/integration_accounts', {
    code: linkedInCode,
    type: 'linkedin',
    redirect_uri: redirectPath,
  });

export const getIntegrationAccounts = (type) => baseService.get('/member/integration_accounts', { params: { type } });

export const deleteIntegrationAccount = (id) => baseService.delete(`/member/integration_accounts/${id}`);
